import { BigNumber } from 'ethers';

export const calculateGasMargin = (value: string) => {
    const bigValue = BigNumber.from(value);
    // const newValue = bigValue.mul(BigNumber.from(10000).add(BigNumber.from(1000))).div(BigNumber.from(10000));
    const newValue = bigValue.mul(BigNumber.from(10));
    // const newValue = bigValue.mul(BigNumbers.from(5));
    return newValue.toString();
};
